import {
	useBlockProps,
	InnerBlocks,
	RichText,
	RawHTML,
} from "@wordpress/block-editor";

const Save = (props) => {
	const { attributes } = props;
	const { titleOne, titleTwo } = attributes;

	return (
		<section {...useBlockProps.save({ className: "relative my-20" })}>
			<div className="absolute z-0 h-40 rounded-md opacity-50 -top-6 rect-selector bg-cgBlue-brandbook w-36"></div>

			<div className="relative z-10 py-4 my-10 bg-cgWhite-ContrastTrue md:py-10">
				<div className="!w-10/12 thumb-swiper-instalations swiper bg-cgWhite-ContrastTrue">
					<div className="items-center md:justify-center swiper-wrapper">
						<div className="swiper-slide">
							<RichText.Content
								tagName="h5"
								id="cg_block_titleOne"
								className="text-center transition-all cursor-pointer"
								value={titleOne}
							/>
						</div>
						<div className="swiper-slide">
							<RichText.Content
								tagName="h5"
								id="cg_block_titleTwo"
								className="text-center transition-all cursor-pointer"
								value={titleTwo}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className="my-10">
				<div className="swiper swiper-instalations">
				<div className="swiper-wrapper">
						<InnerBlocks.Content />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Save;
